import { ExternalLink } from 'lucide-react';

import { cn } from '@/marketing/lib/utils';
import { formatDate } from '@/marketing/lib/formatters';
import type { ContentTrackingRow } from '@/marketing/models/contentTracking';

const STATUS_TONES: Record<string, string> = {
  DELIVERED: 'tw-text-emerald-700',
  OUT_FOR_DELIVERY: 'tw-text-emerald-700',
  IN_TRANSIT: 'tw-text-violet-700',
  EXCEPTION: 'tw-text-rose-700',
  RETURNED: 'tw-text-rose-700',
  LOST: 'tw-text-rose-700',
};

function statusLabel(status: string): string {
  return status
    .toLowerCase()
    .split('_')
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(' ');
}

// Package status comes from the marketing fulfillment order; a sheet-imported tracking number only gets a carrier link.
export function ContentTrackingShipmentCell({ row }: { row: ContentTrackingRow }) {
  return (
    <div className="tw-flex tw-min-w-[180px] tw-flex-col tw-gap-0.5 tw-text-[12px]">
      <div className="tw-flex tw-items-center tw-gap-1 tw-font-mono tw-text-[11px]">
        {row.shippingTracking ? (
          row.trackingUrl ? (
            <a
              href={row.trackingUrl}
              target="_blank"
              rel="noreferrer"
              className="tw-inline-flex tw-items-center tw-gap-1 tw-text-blue-700 hover:tw-underline"
            >
              {row.shippingTracking}
              <ExternalLink className="tw-h-3 tw-w-3" />
            </a>
          ) : (
            <span>{row.shippingTracking}</span>
          )
        ) : (
          <span className="tw-text-muted-foreground">No tracking</span>
        )}
      </div>
      {row.packageStatus ? (
        <div className={cn('tw-font-semibold', STATUS_TONES[row.packageStatus] ?? 'tw-text-foreground')}>
          {statusLabel(row.packageStatus)}
          <span className="tw-ml-1 tw-font-normal tw-text-muted-foreground">
            {row.deliveredAt
              ? `· ${formatDate(row.deliveredAt)}`
              : row.packageStatusUpdatedAt
                ? `· ${formatDate(row.packageStatusUpdatedAt)}`
                : ''}
          </span>
        </div>
      ) : (
        <div className="tw-text-[11px] tw-text-muted-foreground">
          {row.orderId ? 'Status pending' : 'Manual shipment'}
        </div>
      )}
    </div>
  );
}
